export const commercialPermits = (state) => state.commercialPermits
export const people = (state) => state.people
